const EnquiryTypes = {
  generalEnquiry: { radioLabel: "General enquiry", detailLabel: "general" },
  serviceIssues: { radioLabel: "Service issues", detailLabel: "service issue" },
  lostProperty: { radioLabel: "Lost property", detailLabel: "lost property" },
  staff: { radioLabel: "Staff", detailLabel: "staff" },
  serviceUpdates: {
    radioLabel: "Service updates",
    detailLabel: "service update",
  },
};

export default EnquiryTypes;
